import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { TESTIMONIALS } from '../data/content';
export function Testimonials() {
  return <section className="bg-ink py-10 sm:py-12" aria-labelledby="testimonials-title" data-id="element-179" data-mp="3fze2luf5exu3">
      <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-8" data-id="element-180" data-mp="3b0knxyo4l0sc">
        <SectionHeading title="What Functional Coaches Are Saying" data-id="element-181" data-mp="3b01el6cjjkpx" />

        <ul className="mt-6 flex snap-x snap-mandatory gap-3 overflow-x-auto pb-3 lg:gap-4" style={{
        scrollbarWidth: 'thin'
      }} data-id="element-182" data-mp="3700rkxbdm179">
          {TESTIMONIALS.map(item => <li key={item.name} className="flex min-w-[82%] snap-start flex-col rounded-lg border border-line bg-panel p-4 sm:min-w-[46%] sm:p-5 lg:min-w-0 lg:flex-1" data-id="element-183" data-mp="2x1uqghxe8z3g">
              <QuoteIcon className="h-4 w-4 text-gold/70" aria-hidden="true" data-id="element-184" data-mp="v8591v8ft91q" />
              <p className="mt-2 flex-1 text-[12.5px] leading-snug text-cream/85 sm:text-[13.5px]" data-id="element-185" data-mp="qa3p7836t5p7">
                {item.quote}
              </p>
              <div className="mt-3 border-t border-line pt-2.5" data-id="element-186" data-mp="h8179n3x8ejy">
                <p className="font-display text-[15px] font-bold uppercase tracking-wide text-cream" data-id="element-187" data-mp="m62mty251vqo">
                  {item.name}
                </p>
                <p className="text-[11px] font-medium leading-snug text-gold" data-id="element-188" data-mp="c6vczkum4j8b">
                  {item.role}
                </p>
              </div>
            </li>)}
        </ul>

        <p className="text-center text-[9.5px] font-medium uppercase tracking-[0.16em] text-mutedtext lg:hidden" data-id="element-189" data-mp="zyscccgvlisj">
          Swipe to read more
        </p>
      </div>
    </section>;
}